import React from "react";
import { startEurekaLogin } from "./utils";

export function useEurekaLogin() {
  const login = React.useCallback(() => {
    startEurekaLogin();
  }, []);

  return { login };
}
